import React from 'react';
import Icon from '../../../components/AppIcon';

const ShipmentDetailsCard = ({ shipment, shipmentItems, weight, dimensions }) => {
  // Use item_name directly from items returned by RPC get_public_tracking
  const items = shipmentItems || shipment?.items || [];
  let packageDescription = null;

  if (items?.length === 1) {
    const item = items?.[0];
    const name = item?.item_name;
    const qty = item?.quantity || 1;
    if (name) {
      packageDescription = qty > 1 ? `${name} ×${qty}` : name;
    }
  } else if (items?.length > 1) {
    const names = items?.map(item => item?.item_name)?.filter(Boolean);
    if (names?.length > 0) {
      packageDescription = names?.join(', ');
    } else {
      packageDescription = `${items?.length} articles`;
    }
  }

  return (
    <div className="bg-card border border-border rounded-lg p-5">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Info" size={20} className="text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Détails de l'envoi</h3>
      </div>
      <div className="space-y-4">
        {packageDescription && (
          <div className="flex items-start justify-between py-2 border-b border-border">
            <div className="flex items-center space-x-2">
              <Icon name="Package" size={16} className="text-muted-foreground mt-1" />
              <span className="text-sm text-muted-foreground">Colis</span>
            </div>
            <span className="text-sm font-medium text-foreground text-right max-w-[70%]">
              {packageDescription}
            </span>
          </div>
        )}
        
        {weight && (
          <div className="flex items-center justify-between py-2 border-b border-border">
            <div className="flex items-center space-x-2">
              <Icon name="Weight" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">Poids</span>
            </div>
            <span className="text-sm font-medium text-foreground">{weight} kg</span>
          </div>
        )}
        
        {dimensions && (
          <div className="flex items-center justify-between py-2">
            <div className="flex items-center space-x-2">
              <Icon name="Ruler" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">Dimensions</span>
            </div>
            <span className="text-sm font-medium text-foreground">{dimensions}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShipmentDetailsCard;